import React, { useState } from 'react'

import useScrollMagic from './useScrollMagic'
import useImpact      from './useImpact'

import Content from './Content'

const App = props => {
  const [ panel, setPanel ]               = useState('#home')
  const [ showNav, setShowNav ]           = useState(false)
  const [ showContent, setShowContent ]   = useState(false)
  const [ projectPanel, setProjectPanel ] = useState(null)
  const [ activeMarker, setActiveMarker ] = useState(null)

  const scrollMagic = useScrollMagic(panel, projectPanel)
  const impact      = useImpact(props.widgets)

  const setProjectPanelWithScrollMagic = newProjectPanel => {
    scrollMagic.projectPanel(newProjectPanel)
    setProjectPanel(newProjectPanel)
  }

  const openPanel = (newPanel, _showContent=true) => {
    scrollMagic.panel(newPanel)
    setPanel(newPanel)
    setShowNav(false)
    setShowContent(_showContent)
    setProjectPanel(null)
  }

  const openProjectPanel = newProjectPanel => {
    if ((!showContent && innerWidth < 992) || panel != '#projects') {
      openPanel('#projects')
      setTimeout(() => setProjectPanel(newProjectPanel), 250)
    } else if (projectPanel != newProjectPanel)
      setProjectPanelWithScrollMagic(newProjectPanel)

    setActiveMarker(null)
    setShowContent(true)
  }

  const handleMapMarkerBlur = e => {
    if (e.target.classList.contains('map-marker-toggle') ||
      (e.target.closest && e.target.closest('.map-marker')))
      return

    setActiveMarker(null)
  }

  return (
    <Content
      {...props}
      impact={impact}
      panel={panel}
      setPanel={setPanel}
      openPanel={openPanel}
      showNav={showNav}
      setShowNav={setShowNav}
      showContent={showContent}
      setShowContent={setShowContent}
      projectPanel={projectPanel}
      setProjectPanel={setProjectPanelWithScrollMagic}
      openProjectPanel={openProjectPanel}
      activeMarker={activeMarker}
      setActiveMarker={setActiveMarker}
      handleMapMarkerBlur={handleMapMarkerBlur}
    />
  )
}

export default App
